import { API } from '../../../../common/api/constants';

// ПОЛУЧИТЬ ВСЕ ЗАКАЗЫ
export const GET_ALL_ORDERS = `${API}/order/carrier/{profile_id}`;

// ПОЛУЧИТЬ ВСЕ ЗАКАЗЫ ПО ФИЛЬТРУ
export const GET_FILTER_ORDERS = `${API}/order/orders/filter/{profile_id}`;

// ПОЛУЧИТЬ ЗАКАЗ ПО ID
export const GET_ORDER_BY_ID = `${API}/order/order/{order_id}/profile/{profile_id}`;

// СОЗДАТЬ НОВЫЙ ЗАКАЗ
export const CREATE_ORDER = `${API}/order/order/profile_carrier/{profile_id}`;

// ОБНОВИТЬ ЗАКАЗ
export const UPDATE_ORDER = `${API}/order/order_extended/{order_id}/profile_carrier/{profile_id}`;

// ПОЛУЧИТЬ ЛОГ ПО ЗАКАЗУ
export const GET_ORDER_LOG = `${API}/order/{order_id}/log/profile/{profile_id}`;

// ПОЛУЧИТЬ ЛОГ ПО ЗАКАЗУ
export const GET_ORDER_REPORT = `${API}/order/report/{order_id}`;

// СКАЧАТЬ PDF ДОГОВОРА ФРАХТОВАНИЯ ТС ДЛЯ ПЕРЕВОЗКИ ПАССАЖИРОВ И БАГАЖА ПО ЗАКАЗУ
export const DOWNLOAD_CONTRACT_BY_ORDER_ID = `${API}/utility/pdf/download/contract/order/{order_id}/profile/{profile_id}`;

// Скачать PDF Уведомления об организованной перевозке группы детей автобусами (с программой маршрута) из Заказа по Профилю Перевозчика
export const DOWNLOAD_NOTIFICATION_TO_GIBDD = `${API}/utility/pdf/download/gibdd-notification-with-schema/order/{order_id}/profile/{profile_id}`;

// УДАЛИТЬ ЗАКАЗ ПО ID
export const ARCHIEVE_ORDER = `${API}/order/order/{order_id}/carrier/{profile_id}`;

// ПОЛУЧИТЬ ДОПЛАТЫ ПО ЗАКАЗУ
export const GET_ORDER_SURCHARGE_PAYMENT = `${API}/order/orders/{order_id}/surcharges`;

// НАЗНАЧИТЬ\ОБНОВИТЬ ВОДИТЕЛЯ НА ЗАКАЗ
export const ASSIGN_DRIVER = `${API}/offers/{offer_id}/drivers`; // PUT
